<script lang="ts" module>
	let windowWidth = $state(0);

	const _isMobile = $derived(windowWidth < 1050);
	export const isMobile = () => _isMobile;
</script>

<script lang="ts">
	import Route from "@-/router/Route.svelte";
	import RouteGroup from "@-/router/RouteGroup.svelte";
	import { setupRouter } from "@-/router/lib.svelte.ts";
	import { setupSessions } from "@-/social-api/sessions.svelte.ts";
	import Failed from "./layout/Failed.svelte";
	import NotFound from "./layout/NotFound.svelte";
	import Sidebar from "./layout/Sidebar.svelte";
	import Toasts from "./layout/Toasts.svelte";

	setupRouter();
	setupSessions();
</script>

<svelte:window bind:innerWidth={windowWidth} />

<RouteGroup>
	{#snippet notFound()}
		<NotFound />
	{/snippet}

	{#snippet failed(error, _retry)}
		<Failed {error} />
	{/snippet}

	<!-- TODO logged out home? -->
	<Route pattern="/" page={() => import("./post/pages/Home.svelte")} />

	<Route pattern="/settings/accounts" page={() => import("./settings/pages/Accounts.svelte")} />
	<Route pattern="/settings/appearance" page={() => import("./settings/pages/Appearance.svelte")} />
	<Route pattern="/settings/bluesky" page={() => import("./settings/pages/Bluesky.svelte")} />

	<Route pattern="/:network/:author/post/:id" page={() => import("./post/pages/Thread.svelte")} />

	{#if import.meta.env.DEV}
		<Route
			pattern="/dev/long-loading/:number"
			page={() => import("./pages/dev/LongLoading.svelte")}
		/>
		<Route pattern="/dev/client/:network" page={() => import("./pages/dev/Client.svelte")} />
		<Route pattern="/dev/zoo/input" page={() => import("./pages/dev/InputZoo.svelte")} />
		<Route pattern="/dev/zoo/time" page={() => import("./pages/dev/TimeZoo.svelte")} />
		<Route pattern="/dev/error" page={() => import("./pages/dev/Error.svelte")} />
	{/if}

	<Sidebar />
	<Toasts />
</RouteGroup>

{#if import.meta.env.DEV}
	{#await import("svelte-render-scan") then { RenderScan }}
		<RenderScan initialEnabled={false} />
	{/await}
{/if}

<style>
	:root {
		--viewport: desktop;

		container-type: size;

		@media (width < 1050px) {
			--viewport: mobile;
		}
	}

	:global(#app) {
		--_header-padding: var(--s-s);
		--_header-height: calc((2 * var(--_header-padding)) + 1cap);
		--_layout-gap: var(--s-2xs);

		isolation: isolate;

		display: grid;
		grid:
			".    header   ." var(--_header-height)
			"left main aside"
			/ auto min(100%, var(--set-contentWidth)) auto;
		gap: var(--_layout-gap);

		/* https://ishadeed.com/article/new-viewport-units/#:~:text=Be%20careful%20with%20the%20dvh,is%20scrolling%20up%20or%20down. */
		/* stylelint-disable-next-line defensive-css/require-dynamic-viewport-height */
		min-block-size: 100vb;

		@container style(--viewport: mobile) {
			display: block;

			> :global(header) {
				block-size: var(--_header-height);
			}

			> :global(* + *) {
				margin-block-start: var(--_layout-gap);
			}
		}
	}
</style>
